import { Injectable } from '@angular/core';
import { Url } from 'shared/services/utils/url.service';
import { NotificationBarService } from 'shared/services/notification/notification-bar.service';
import { bcEnums } from 'common/common/constants/boldchat-enums';
import { bcStates } from 'common/common/states';
import { StateServiceWrapper } from 'shared/services/state-service-wrapper/state-service-wrapper';
import { WindowService } from 'shared/services/window/window.service';

@Injectable({
  providedIn: 'root'
})
export class SsoErrorResolverService {
  constructor(private bcNotificationService: NotificationBarService,
              private $state: StateServiceWrapper,
              private window: WindowService) {
  }

  resolve() {
    const errorCode = this._getSearchParam('errorCode');
    if (errorCode === bcEnums.loginErrorCodes.PRODUCT_MISMATCH) {
      let details = this._getSearchParam('errorDetails');
      let domains = details.split(':');
      let newHost = this.window.location.hostname.replace(domains[0], domains[1]);
      const aid = this._getSearchParam('aid');
      const un = this._getSearchParam('un');
      const newUrl = Url.format({
        protocol: this.window.location.protocol,
        hostname: newHost,
        port: this.window.location.port,
        pathname: bcStates.login.url,
        query: aid ? { aid: aid } : un ? { un: un } : null
      });
      this.bcNotificationService.addNotification({ id: 'sso-error', content: 'You should use this domain: ' + newUrl });
    } else {
      this.bcNotificationService.addNotification({ id: 'sso-error', content: 'bcCommon.ssoErrorMessage' });
    }
    this._navigateToUrl(this.$state, bcStates.login.url);
  }

  private _getSearchParam(paramName) {
    if (!this.window.location.search) {
      return;
    }
    const foundParam = this.window.location.search.slice(1).split('&')
      .find(param => param.indexOf(`${paramName}=`) === 0);
    return foundParam && foundParam.substr(`${paramName}=`.length);
  }

  private _navigateToUrl($state, url) {
    $state.go(url, {}, { queryParamsHandling: 'preserve' });
  }
}
